import { ConditionsNew } from '@retail/calculus/types';
import { CheckboxFilterGroup, SideFilters } from '@retail/components';
import { ConditionTypeChip } from './ConditionTypeChip';
import { getHierarchyLevelLabel } from '@retail/calculus/utils';
import { useAppTFunction } from '@retail/app/i18n';
import { useMemo } from 'react';

interface Props {
  showFilters: boolean;
  draftConditions: ConditionsNew[];
  selectedConditionIds: number[];
  salesPriceConditionsIsEnabled: boolean;
  updateConditionIds: (id: number) => void;
}

export function AssortmentPriceChangesFilter({
  showFilters,
  draftConditions,
  selectedConditionIds,
  salesPriceConditionsIsEnabled,
  updateConditionIds,
}: Props) {
  const t = useAppTFunction();

  const options = useMemo(
    () =>
      draftConditions.map((condition) => ({
        value: condition.id,
        label: (
          <ConditionTypeChip
            calculusArea={condition.type}
            labelDetails={getHierarchyLevelLabel({ t, bindingType: condition.bindingType })}
            salesPriceConditionsIsEnabled={salesPriceConditionsIsEnabled}
            height={44}
          />
        ),
      })),
    [draftConditions, salesPriceConditionsIsEnabled, t]
  );

  return (
    <SideFilters showFilters={showFilters}>
      <CheckboxFilterGroup
        label={t('calculus.filterConditions')}
        options={options}
        selected={selectedConditionIds}
        onToggle={updateConditionIds}
        indent={0}
      />
    </SideFilters>
  );
}
